<template>
  <div class="container">
    <div class="d-flex flex-column flex-md-row justify-content-center align-items-center">
      <img
        class="img-fluid"
        src="https://mailimages.trailfinders.com/inxmail/RegentVIP-Invitation/regent.gif"
        alt="Regent Seven Seas Cruises"
      />
      <img
        class="img-fluid"
        src="https://mailimages.trailfinders.com/inxmail/RegentVIP-Invitation/amp.gif"
        alt
      />
      <img
        class="img-fluid"
        src="https://mailimages.trailfinders.com/inxmail/RegentVIP-Invitation/tf.gif"
        alt="Trailfinders"
      />
    </div>
    <div class="d-flex justify-content-center py-3" v-show="!dataSuccess">
      <div class="px-5 py-3 border border-light d-flex flex-column flex-sm-row justify-content-evenly">
     
          <b-form-radio
            v-model="agreed"
            name="some-radios"
            value="accepted"
			class="px-3"
          >&nbsp;I am attending</b-form-radio>
          <b-form-radio
            v-model="agreed"
            name="some-radios"
            value="not_accepted"
			class="px-3"
          >&nbsp;I am not attending</b-form-radio>
      </div>
    </div>

    <div class="row pb-3" v-show="!dataSuccess">
      <div class="col-md-3">&nbsp;</div>
      <div class="col-md-6">
        <b-form-input v-model="email" placeholder="Enter your email" class="form-control"></b-form-input>
      </div>
    </div>
 
    <div class="row g-0" v-show="!dataSuccess">
      <div class="col-md-3">&nbsp;</div>
      <div class="col-md-6">
        <b-form-textarea
          class="form-control w-100 p-2 m-0"
          id="textarea"
          v-model="questions"
          placeholder="Please advise us of the number of guests you are bringing, along with any other questions."
          rows="6"
          max-rows="6"
        ></b-form-textarea>
      </div>
    </div>
    <div class="row py-3" v-show="!dataSuccess">
      <div class="col-md-3">&nbsp;</div>
      <div class="col-md-6">
        <button
          class="btn btn-primary m-b-xl btn-block text-center"
          @click="saveDetails"
          :disabled="email === ''"
        >Send Details</button>
      </div>
    </div>

    <div class="row m-y-xl pt-3">
      <div class="col-md-3">&nbsp;</div>
      <div class="col-md-6 align-center">
        <b-alert variant="success" :show="dataSuccess">
          <p style="text-align: center">You have successfully sent your details.</p>
        </b-alert>
      </div>
    </div>
    <div class="row m-y-xl d-flex justify-content-center">
      <div class="col-12"></div>
    </div>
  </div>
</template>

<script>
import { saveRegentDetails } from "@/services/api.js";
export default {
  data() {
    return {
      questions: "",
      email: "",
      agreed: "accepted",
      dataSuccess: false,
      dataError: false,
    };
  },
  async mounted() {
    this.email = this.$route.query.e;
  },
  methods: {
    async saveDetails() {
      this.dataSuccess = false;
      this.dataError = false;
      let res = await saveRegentDetails({ email: this.email, questions: this.questions, agreed: this.agreed });
      if (res.status && res.status <= 399) {
        this.dataSuccess = true;
        console.log("done");
      } else {
        this.dataError = true;
        console.log("error");
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/index";
</style>
